// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const languages = [
  'en', 'fa', 'hi', 'ar', 'it', 'tl', 'vi', 'ko', 'pt', 'sw',
  'tr', 'ku', 'th', 'ms', 'he', 'ru', 'uk', 'ur','es', 'fr', 'de', 'ja', 'zh'
];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: languages,
    preload: ['en'],
    backend: {
      loadPath: '/locales/{{lng}}/translation.json'
    },
    detection: {
      order: ['path', 'cookie', 'htmlTag', 'localStorage', 'navigator'],
      caches: ['cookie']
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;